const utils = require('./utils');
const hooks = require('./hooks');

module.exports = Object.assign({}, utils, { hooks });
